import { createStore, applyMiddleware, compose, combineReducers } from "redux";
//import reduxImmutableStateInvariant from "redux-immutable-state-invariant";
import thunk from "redux-thunk";

import authentication from "./authentication/reducers";
import configuration from "./configuration/reducers";
import embedInfo, {pbiReportsForUsers} from "./embeddedpbireports/reducers";
import callsInProgress from "./common/reducers";
import welcomeMessageAccepted from "./welcome/reducers";

const rootReducer = combineReducers({
    authentication,
    callsInProgress,
    configuration,
    embedInfo,
    pbiReportsForUsers,
    welcomeMessageAccepted
});

export type RootState = ReturnType<typeof rootReducer>;

const stateName = "state";

export const loadState = (storage: any) => {
    try {
        const serializedState = storage && storage.getItem ? storage.getItem(stateName) : null;
        return null === serializedState ? undefined : JSON.parse(serializedState);
    } catch (error) {
        console.error(error.message);
        return undefined;
    }
};

export const saveState = (state: RootState, storage: any) => {
    try {
        storage.setItem(stateName, JSON.stringify(state));
    } catch (error) {
        console.error(error.message);
    }
};

const composeEnhancers = /*window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ||*/ compose; // add support for Redux dev tools

// use sessionStorage for app state, create store, wire store to be saved on change
const storage = null; //window.sessionStorage;

const store = createStore(
    rootReducer,
    loadState(storage),
    composeEnhancers(applyMiddleware(thunk /*, reduxImmutableStateInvariant()*/))
);

if (storage) {
    store.subscribe(() => saveState(store.getState(), storage));
}

export default store;

export type AppDispatch = typeof store.dispatch;
